import { ChatMessage } from '../types/interfaces/message';

export function findMessageIndex(
  messages: ChatMessage[],
  incoming: ChatMessage,
): number {
  if (incoming.tempId) {
    const tempIndex = messages.findIndex(
      (message) => message.tempId === incoming.tempId,
    );
    if (tempIndex !== -1) return tempIndex;
  }

  if (incoming.messageId) {
    const messageIdIndex = messages.findIndex(
      (message) => message.messageId === incoming.messageId,
    );
    if (messageIdIndex !== -1) return messageIdIndex;
  }

  if (!incoming.tempId && !incoming.messageId && incoming.id > 0) {
    return messages.findIndex(
      (message) =>
        message.id === incoming.id && message.idChat === incoming.idChat,
    );
  }

  return -1;
}

export function messageIdentityKey(message: ChatMessage): string {
  if (message.tempId) return `temp-${message.tempId}`;
  if (message.messageId) return `message-${message.messageId}`;
  if (message.id > 0) return `id-${message.id}-chat-${message.idChat}`;

  const timestamp = new Date(message.createdAt).getTime();
  return `local-${message.senderId}-${timestamp}`;
}
